import { useEffect } from "react";
import { useLazyGetConsumTransactionsFilteredQuery } from "../../../features/consumtransactions/consumTransApiSlice";

const DropdownConsumOptionsFetcher = ({ permanentFilters = {}, onDataFetched }) => {
  const [triggerFetch, { data, isLoading, isError }] = useLazyGetConsumTransactionsFilteredQuery();

  useEffect(() => {
    // Fetch data with only permanent filters to populate dropdown options
    triggerFetch({
      page: 1,
      limit: 99999,
      filters: permanentFilters,
    });
  }, [permanentFilters, triggerFetch]);

  useEffect(() => {
    if (data && !isLoading && !isError) {
      onDataFetched(data);
    }
  }, [data, isLoading, isError, onDataFetched]);

  return null; // This component doesn't render anything
};

export default DropdownConsumOptionsFetcher;

